import PropTypes from 'prop-types';
import React from 'react';
import LoadingPlaceholderFullPage from 'components/shared/LoadingPlaceholderFullPage';
import usePollAnswersForActivity from 'api-new/stim-based/usePollAnswersForActivity';
import { PollActivityEngagementIndicator as RCPollActivityEngagementIndicator } from '@visionslive/reporting-components';
import _ from 'lodash';
import ProjectParticipantRole from 'enums/ProjectParticipantRole';
import useParticipantsForFocusGroupActivity from 'api-new/stim-based/useParticipantsForFocusGroupActivity';

const PollActivityEngagementIndicator = ({ activityId, crossSessionId }) => {
    const { data: pollAnswers, isLoading: isLoadingPollAnswers } = usePollAnswersForActivity({ activityId, crossSessionId });
    const { data: participants, isLoading: isLoadingParticipants } = useParticipantsForFocusGroupActivity({ activityId, crossSessionId });

    if (isLoadingPollAnswers || isLoadingParticipants) {
        return <LoadingPlaceholderFullPage />;
    }

    const respondents = participants?.filter(x => x.projectParticipantRole === ProjectParticipantRole.RESPONDENT);
    const uniqueRespondents = _.uniqBy(respondents, 'focusGroupUserId'); // Handles the same respondent participating in multiple sessions
    const respondentsAsObject = _.keyBy(uniqueRespondents, 'focusGroupUserId');

    return (
        <RCPollActivityEngagementIndicator
            answers={pollAnswers}
            participants={respondentsAsObject}
            sx={{
                height: 35
            }}
        />
    );
};

PollActivityEngagementIndicator.propTypes = {
    activityId: PropTypes.string,
    crossSessionId: PropTypes.string,
    focusGroupId: PropTypes.string
};

export default PollActivityEngagementIndicator;
